<template>
    <v-dialog v-model="active" width="850">
        <v-sheet class="overflow-hidden">
            <v-row class="bg-grey-lighten-5 c-search-form">
                <v-col cols="auto" md="4" xl="4" lg="4" :class="{
                    'pa-11 pb-0 pr-0': $vuetify.display.mdAndUp,
                    'pa-8 pb-0': $vuetify.display.smAndDown
                }">
                    <div class="has-guy">
                        <p class="text-h5 font-weight-bold">{{$t('contact-form.write_us')}}</p>
                    </div>
                </v-col>
                <v-col :class="{
                    'pa-11': $vuetify.display.mdAndUp,
                    'pa-8': $vuetify.display.smAndDown
                }">
                    <p class="text-body-3 font-weight-medium text-black mb-2">{{$t('contact-form.email')}}: <span class="text-red">*</span></p>
                    <v-text-field
                        variant="outlined"
                        :rules="[rules.required, rules.email]"
                        density="compact"
                        validate-on="blur"
                        autocomplete="email"
                        type="email"
                        v-model="email"
                        bg-color="white"
                    ></v-text-field>
                    <p class="text-body-3 font-weight-medium text-black mb-2">{{$t('contact-form.query')}}: <span class="text-red">*</span></p>
                    <v-textarea
                        variant="outlined"
                        rows="4"
                        :rules="[rules.required]"
                        v-model="question"
                        bg-color="white"
                        :placeholder="$t('contact-form.placeholder')"
                    >
                    </v-textarea>
                    <v-row align="center">
                        <v-col>
                            <div @click="go(route('gdpr'))" class="text-tiny-link text-grey c-em">{{$t('contact-form.personal_1')}} <span class="text-decoration-underline c-link ">{{$t('contact-form.personal_2')}}</span></div>
                        </v-col>
                        <v-col cols="auto">
                            <v-btn
                                color="orange"
                                variant="flat"
                                class="px-8"
                                :height="48"
                                :loading="loading"
                                @click="sendQuestion"
                            >
                                <p class="text-subtitle-1 font-weight-bold text-white">{{$t('contact-form.send_action')}}</p>
                            </v-btn>
                        </v-col>
                        <v-col cols="auto">
                            <v-btn
                                color="grey"
                                variant="flat"
                                class="px-6"
                                :height="48"
                                @click="active = false"
                            >
                                <p class="text-subtitle-1 font-weight-bold text-white">{{$t('contact-form.storno_action')}}</p>
                            </v-btn>
                        </v-col>
                    </v-row>
                </v-col>
            </v-row>
        </v-sheet>
    </v-dialog>
</template>
<script setup>
import {computed, inject, ref, watch} from "vue";
import {trans} from "laravel-vue-i18n";
import { router } from '@inertiajs/vue3';
const emit = defineEmits(['update:modelValue']);
const props = defineProps({
   modelValue:Boolean,
   email: String
})

const active = computed({
    get() {
        return props.modelValue
    },
    set(val) {
        emit('update:modelValue', val)
    }
})
const go = (where) => {
    active.value = false;
    router.visit(where);
}
const loading = ref(false);
const sendQuestion = () => {
    loading.value = true;
    if(email.value != '' && question.value != '') {
        router.post(route('contact.query'), {
            email: email.value,
            question: question.value
        }, {
            onSuccess: () => {
                email.value = '';
                question.value = '';
                active.value = false;
                loading.value = false;
            }
        });
    }
}
const email = ref('');
const question = ref('');

watch(() => props.email, (now) => {
    email.value = now;
}, { immediate: true })


const rules = {
    required: value => !!value || trans('contact-form.required'),
    counter: value => value.length <= 20 || trans('contact-form.max_20'),
    email: value => {
        const pattern = /^(([^<>()[\]\\.,;:\s@"]+(\.[^<>()[\]\\.,;:\s@"]+)*)|(".+"))@((\[[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}])|(([a-zA-Z\-0-9]+\.)+[a-zA-Z]{2,}))$/
        return pattern.test(value) || trans('contact-form.not_valid_email')
    }
}
const route = inject('route');
</script>
<style scoped lang="scss">
@use '../../../../plugins/vuetify-settings' as *;
@use 'vuetify/lib/styles/settings/variables' as *;
@use 'sass:map';
.has-guy {
    width: 100%;
    height: 100%;
    position: relative;
    background-image: url('../../../../assets/images/search/look.png');
    background-position: center bottom;
    background-size: contain;
    background-repeat: no-repeat;
    @media #{map.get($display-breakpoints, 'xs')} {
        background: none;
    }
}
.c-link {
    cursor:pointer;
    &:hover {
        text-decoration: none!important;
        background-color: map.get($orange, 'lighten-4');
        padding: 2px 5px;
        border-radius: 5px;
        margin: -2px -5px;
        color: map.get($orange, 'base')
    }
}
</style>
